<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>البيع المباشر</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع عمليات البيع المباشر
                                <div v-show="$per.value.saveDirectSales" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='tabelValidationErrors'>
                                <ul v-if='tabelValidationErrors'>
                                    <li v-for='err in tabelValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-4 col-md-4 col-sm-6'>
                                    <label>الفرع</label>
                                    <select class="form-control"  v-model="table_branch_id">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate  :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate  :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                              <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                    <b> عرض </b>
                                  </button>
                              </div>
                              <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                  <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                    <b> طباعة </b>
                                  </button>
                              </div>
                              <br>
                              <br>
                              <br>
                              <br>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الصنف</th>
                                          <th style='text-align: center'>السعر</th>
                                          <th style='text-align: center'>الكمية</th>
                                          <th style='text-align: center'>الاجمالى</th>
                                          <th style='text-align: center'>التاريخ</th>
                                          <th style='text-align: center'>الخزنة</th>
                                          <th style='text-align: center'>المخزن</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.item}}</td>
                                          <td align='center'>{{record.price}}</td>
                                          <td align='center'>{{record.quantity}}</td>
                                          <td align='center'>{{record.total}}</td>
                                          <td align='center'>{{record.sale_date}}</td>
                                          <td align='center'>{{record.treasury_name}}</td>
                                          <td align='center'>{{record.store_name}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteDirectSales" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editDirectSales" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <label>الفرع:</label>
                                     <select  v-model='record.branch_id' @change='changeBranche($event.target.value)' class="form-control" style="padding: 0px">
                                       <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='col-lg-3 col-sm-3'>
                                     <label>المنتج:</label>
                                     <select  @change='GetPrice($event)' class="form-control" style="padding: 0px" v-model="record.item_id">
                                       <option v-for="contractItem in items" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                                         {{ contractItem.item }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-2'>
                                     <label>السعر:</label>
                                     <input v-model='record.price'  @keypress="isNumber($event)" class='form-control' name='price' type='text'>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-2'>
                                     <label>الكمية:</label>
                                     <input v-model='record.quantity'  @keypress="isNumber($event)" class='form-control' name='quantity' type='text'>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-2'>
                                     <label>الاجمالى:</label>
                                     <input v-model='record.total'  @keypress="isLocked($event)" class='form-control' name='total' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <tbDate  :mytitle='dateTitle' v-model= 'record.sale_date' ></tbDate>
                                 </div>
                                 <div class='col-lg-3 col-sm-3'>
                                     <label>الخزنة:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                                       <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                                         {{ treasury.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='col-lg-6 col-sm-6'>
                                     <label>المخزن:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.store_id">
                                       <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                                         {{ store.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='col-lg-12 col-md-12 col-sm-12'>
                                   <div class="form-group">
                                       <label>ملاحظات:</label>
                                       <input v-model='record.notes' class='form-control' name='nickname' type='text'>
                                   </div>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'direct_sales',
  data () {
    return {
      dateTitle: 'التاريخ',
      fromTitle: 'من',
      toTitle: 'إلى',
      treasuries: {},
      table_branch_id: '',
      from_date: '',
      to_date: '',
      stores: {},
      items: {},
      branches: {},
      validationErrors: '',
      records: {},
      record: {},
      tabelValidationErrors: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  mounted: function () {
    this.$watch('record', function () {
      this.record.total = parseInt(this.record.quantity || 0) * parseInt(this.record.price || 0)
    }, {deep: true})
  },
  created () {
    this.record.branch_id = localStorage.getItem('BrancheID')
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.branches = JSON.parse(localStorage.getItem('Branches'))
  },
  methods: {
    changeBranche (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.stores = this.branches[i].stores
      }
    },
    GetPrice (event) {
      let i = this.items.findIndex(x => x.id === parseInt(event.target.value))
      if (i > -1) {
        this.record.price = this.items[i].price
      } else {
        this.record.price = 0
      }
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getDirectSales', {
        token: localStorage.getItem('token'),
        branch_id: this.table_branch_id,
        from: this.from_date,
        to: this.to_date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.tabelValidationErrors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
          this.tabelValidationErrors = err.response.data.errors
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branch_id': '', 'item_id': '', 'price': '', 'quantity': '', 'total': '', 'sale_date': '', 'treasury_id': '', 'store_id': '', 'notes': ''}
        this.record.branch_id = localStorage.getItem('BrancheID')
        this.changeBranche(this.record.branch_id)
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'branch_id': recID.branch_id, 'item_id': recID.item_id, 'price': recID.price, 'quantity': recID.quantity, 'total': recID.total, 'sale_date': recID.sale_date, 'treasury_id': recID.treasury_id, 'store_id': recID.store_id, 'notes': recID.notes}
        this.changeBranche(this.record.branch_id)
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveDirectSales', {
        token: localStorage.getItem('token'),
        uid: this.record.uid,
        id: this.record.id,
        branch_id: this.record.branch_id,
        item_id: this.record.item_id,
        price: this.record.price,
        quantity: this.record.quantity,
        total: this.record.total,
        sale_date: this.record.sale_date,
        treasury_id: this.record.treasury_id,
        store_id: this.record.store_id,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteDirectSales', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/DirectSales.vue